export default "__VITE_ASSET__Dp5q8NMy__"